import { Button, CircularProgress, Tooltip } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from '../App';
import { getUser } from '../Service/LoginService';
import { tabChangeDetected, updateStartSubmitAssesmentFlag } from '../Service/QuestionService';
import { loadPopup, loadSuccessPopup } from '../Utils/LoginUtils';
import TestTimer from './Countdown/TestTimer';
import { LeftQuestionBar } from './LeftQuestionBar';
import { Question } from './Question';
import Screenshot from './Screenshot';
import Draggable from 'react-draggable';
import CameraMicTest from './CameraMicTest';
import ConfirmDialog from './ConfirmDialog';

export const processSubmitTest = (assesmentId) => {
    updateStartSubmitAssesmentFlag(assesmentId, 'SUBMITTED').then(response => {
        loadSuccessPopup('Test submitted successfully');
    }).catch(err => {
        console.log('error catched while updateStartSubmitAssesmentFlag-SUBMITTED', err);
        loadPopup(err.code + "- " + err.response.status);
    });
}

export const QuizComponent = () => {
    const [dialogTitle, setDialogTitle] = React.useState('');
    const [dialogMsg, setDialogMsg] = React.useState('');
    const [operation, setOperation] = React.useState('');
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const navigate = useNavigate();
    const { data } = useContext(Store);
    const questions = data !== null ? data?.testSet[0]?.questions : [];
    const assesmentId = data !== null ? data?.assessmentId : "";
    const email = data !== null ? data?.email : "";
    const testSetId = data !== null ? data?.testSet[0]?.testSetId : "";

    const [currQuestionIndex, setCurrQuestionIndex] = useState(0);
    const [finalResultJson, setFinalResultJson] = useState([]);
    const [activeOption, setActiveOption] = useState([]);
  
    const token = getUser();

    const [currentQuestionObj, setCurrentQuestionObj] = useState({
        "questionStatement": "",
        "marks": '',
        "questionType": "",
        "questionCategory": "",
        "options": [
            {
                "optionId": '',
                "optionValue": "",
                "correctOption": ''
            }
        ]
    });

    useEffect(() => {
        if (questions.length) {
            setCurrentQuestionObj(questions[0]);
            setCurrQuestionIndex(0);
        }
    }, [questions]);

    useEffect(() => {
        if (window) {
            window.onblur = () => {
                token && (window.location.pathname !== '/vtaTest/testResult' || window.location.pathname !== '/testResult') && tabChangeDetected(assesmentId);
            }
        }
    }, []);


     // ConfirmDialog methods -------------
  const handleDialogClose = () => {
    setConfirmOpen(false);
  }
  const handleDialogAgree = () => {
    setConfirmOpen(false);
    const op = operation.split('-')[0];
    const testId = operation.split('-')[1];
    if (op === 'assesment') {
        processSubmitTest(assesmentId);
        navigate("/feedback");
    } 

  }


    const handleSubmitTest = (e) => {
        e.preventDefault();
        if (finalResultJson.length === questions.length) {
            processSubmitTest(assesmentId);
            navigate("/feedback");
        }else{
            if (finalResultJson.length === 0) 
            setDialogMsg('No questions attempted, Are you sure to submit?');
            else 
            setDialogMsg('Some of the questions are still unanswered, Are you sure to submit?');
        setDialogTitle('Test Submission !');
        setOperation('assesment-' + assesmentId);
        setConfirmOpen(true);

        }
    }

    return (
        <>
         <ConfirmDialog dialogopen={confirmOpen} dialogTitle={dialogTitle} dialogMsg={dialogMsg}
        handleDialogClose={handleDialogClose} handleDialogAgree={handleDialogAgree} />
        <div className='ps-2' style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
            <div style={{ width: "15%", height: "75vh", overflowY: "auto" }} className="border rounded p-2">
                <div style={{ display: 'flex' }}>
                    <h4 className="text-danger p-1 m-1" style={{ fontWeight: '400' }}>Questions</h4>
                    <h4 className="text-secondary p-1 m-2" style={{ fontWeight: '100', fontSize: '16px' }}>
                        [{(finalResultJson && finalResultJson.length > 0) ? finalResultJson.length : 0}/{(questions && questions.length > 0) ? questions.length : 0}]
                    </h4>
                </div>
                <ol>
                    {
                        questions.length > 0 && questions.map((ques, index) => {
                            return <Tooltip title={ques && ques.questionStatement} placement="right-end" key={index}>
                                <li key={index + ques.qid}
                                    className={finalResultJson.some(q => q.qid === ques.qid) ? 'list-unstyled border rounded p-1 m-1 border-danger' : 'list-unstyled border rounded p-1 m-1'}
                                    onClick={() => {
                                        setCurrentQuestionObj(ques);
                                        setCurrQuestionIndex(index);
                                    }}
                                    style={{
                                        width: '4rem', backgroundColor: currQuestionIndex === index ? "cadetblue" : "",
                                        color: currQuestionIndex === index ? "antiquewhite" : "inherit",
                                        textAlign: "center",
                                        cursor: 'pointer'
                                    }}
                                >
                                    <LeftQuestionBar index={index} />
                                </li>
                            </Tooltip>
                        })
                    }
                </ol>
            </div>
            <div style={{ width: "85%" }} className='ps-2 pe-2'>
                {
                    questions.length > 0 ?
                        <>
                            <div className='bg-light' style={{ display: "flex", justifyContent: "space-between", width: "100%", textTransform: "uppercase" }}>
                                <span className='p-1 ms-2' style={{ width: "3rem", }}>
                                    <span className='text-success' style={{ fontWeight: "", fontSize: "30px" }}>
                                        {currQuestionIndex + 1}
                                    </span>
                                    /{questions.length}
                                </span>
                                <div style={{ display: "flex" }}>
                                <CameraMicTest style={true} />
                                    <span className='p-1 mt-1 me-2'>
                                        <TestTimer />
                                    </span>
                                    <span className='p-1 mt-1 me-2'>
                                        <Button className='bg-danger'
                                            variant='contained' onClick={handleSubmitTest}>
                                            End Test
                                        </Button>
                                    </span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: "center" }}>
                                <Question
                                    currentQuestionObj={currentQuestionObj}
                                    setCurrentQuestionObj={setCurrentQuestionObj}
                                    questions={questions}
                                    currQuestionIndex={currQuestionIndex}
                                    setCurrQuestionIndex={setCurrQuestionIndex}
                                    finalResultJson={finalResultJson}
                                    setFinalResultJson={setFinalResultJson}
                                    activeOption={activeOption}
                                    setActiveOption={setActiveOption}
                                    assesmentId={assesmentId}
                                    email={email}
                                    testSetId={testSetId} />
                            </div>
                        </>
                        : (
                            <CircularProgress style={{ margin: "10.5rem" }}
                                size={100}
                                thickness={2}
                            />
                        )
                }
            </div>
            <Draggable>
            <div style={{ position: 'absolute', top:'3px' }}>
            <Screenshot assesmentId={assesmentId} />
            </div>
            </Draggable>
        </div>
        </>
    )
}
